<template>
  <div class="step-form step-form--centered">
    <h2 class="step-form__title">{{ $t('step2.title') }}</h2>
    <p class="step-form__subtitle">{{ $t('step2.subtitle') }}</p>

    <div class="number-input">
      <button class="number-input__btn" @click="decrement" :disabled="formData.hotelCount <= 1">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14"/></svg>
      </button>
      <input class="number-input__value" type="number" min="1" :value="formData.hotelCount"
             @input="onInput($event.target.value)" />
      <button class="number-input__btn" @click="increment">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg>
      </button>
    </div>

    <span class="step-form__note">{{ $t('step2.label') }}</span>
  </div>
</template>

<script>
export default {
  name: 'HotelCount',
  props: { formData: Object },
  methods: {
    onInput(val) {
      const n = parseInt(val, 10)
      if (!isNaN(n) && n >= 1) {
        this.$emit('update', { hotelCount: n })
        this.syncHotels(n)
      }
    },
    increment() {
      const n = this.formData.hotelCount + 1
      this.$emit('update', { hotelCount: n })
      this.syncHotels(n)
    },
    decrement() {
      if (this.formData.hotelCount > 1) {
        const n = this.formData.hotelCount - 1
        this.$emit('update', { hotelCount: n })
        this.syncHotels(n)
      }
    },
    syncHotels(count) {
      const hotels = [...this.formData.hotels]
      while (hotels.length < count) {
        hotels.push({ street: '', houseNumber: '', zip: '', city: '', description: '', units: 1 })
      }
      if (hotels.length > count) hotels.length = count
      this.$emit('update', { hotels })
    },
  },
}
</script>

<style lang="scss" scoped>
.step-form {
  &--centered { text-align: center; }

  &__title {
    font-size: clamp(1.4rem, 3vw, 2rem);
    font-weight: 800;
    margin-bottom: 0.4rem;
    background: linear-gradient(135deg, #fff 30%, var(--gold-light));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__subtitle {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 2.5rem;
  }

  &__note {
    display: block;
    margin-top: 1rem;
    font-size: 0.78rem;
    color: rgba(255, 255, 255, 0.25);
  }
}

.number-input {
  display: inline-flex;
  align-items: center;
  gap: 0;
  background: rgba(255, 255, 255, 0.04);
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  overflow: hidden;

  &__btn {
    width: 56px;
    height: 64px;
    border: none;
    background: transparent;
    color: var(--gold);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;

    &:hover:not(:disabled) { background: rgba(208, 176, 146, 0.1); }
    &:disabled { opacity: 0.2; cursor: not-allowed; }
  }

  &__value {
    width: 80px;
    height: 64px;
    border: none;
    background: transparent;
    color: #fff;
    font-size: 2rem;
    font-weight: 800;
    text-align: center;
    outline: none;
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  }
}
</style>
